module.exports = __webpack_public_path__ + "static/media/InvoiceManagement-icon.1918581f.svg";